import {
  CasRenderDate,
  CasRenderPhoneNumber,
  CasStackRow,
  CasTable,
} from 'src/compass/shared/components';
import CasLink2 from 'src/compass/shared/components/CasLink/CasLink2';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import { IGeneralObjectType } from 'src/compass/site/util';

interface IProps {
  data: IGeneralObjectType[];
}

export default function ContactsTab({ data }: IProps) {
  return (
    <CasTable
      data={{ result: data }}
      columns={[
        {
          field: 'name',
          label: 'Name',
        },
        {
          field: 'email',
          label: 'Email',
          render: ({ row, column }) => {
            const email = getCasTableCellValue({ row, column });
            if (!email) return null;
            return <CasLink2 href={`mailto:${email}`}>{email}</CasLink2>;
          },
        },
        {
          field: 'phone',
          label: 'Phone',
          render: ({ row, column }) => {
            const linkPhone = getCasTableCellValue({ row, column })
                            .replace(/[^a-zA-Z0-9+]/g, "");

            if (!linkPhone) return null;

            return (
              <CasStackRow>
                <CasLink2 href={`tel:${linkPhone}`} icon="ic:baseline-phone" />
                <CasLink2 href={`sms:${linkPhone}`} icon="fa7-solid:sms" />
                {CasRenderPhoneNumber({ row, column })}
              </CasStackRow>
            );
          },
        },
        {
          field: 'lastTouchpointDate',
          label: 'Last Touchpoint',
          render: CasRenderDate,
        },
      ]}
    />
  );
}
